let FormError = {
  baseStyle: {
    text: {
      fontSize: "text-xs",
      color: "red.500"
    }
  }
};
let FormLabel = {
  baseStyle: {
    color: "rgb(86, 111, 130)",
    fontSize: "text-sm",
    _dark: {
      color: "rgb(181, 181, 181)"
    }
  },
  // from Iris
  sizes: {
    xs: {
      fontSize: "0.731667rem"
    },
    sm: {
      fontSize: "0.731667rem"
    },
    md: {
      fontSize: "0.870556rem"
    },
    lg: {
      fontSize: "1.14833rem"
    },
    xl: {
      fontSize: "1.28722rem"
    }
  }
};
let Form = {
  baseStyle: {
    helperText: {
      color: "text-primary",
      fontSize: "text-xs"
    },
    requiredIndicator: {
      color: "text-primary",
      marginLeft: "50"
    }
  },
  variants: {
    success: {
      container: {
        "> input": {
          borderColor: "green.500"
        }
      },
      helperText: {
        color: "green.500",
        fontSize: "text-xs"
      }
    }
  }
};

export { Form, FormError, FormLabel };
